 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781439635179_COVER from '@/components/9781439635179_cover'
 import A781439635179_FRONT from '@/components/9781439635179_front'
 import A781439635179_TITLEPAGE from '@/components/9781439635179_titlepage'
 import A781439635179_COPYRIGHT from '@/components/9781439635179_copyright'
 import A781439635179_DEDICATION from '@/components/9781439635179_dedication'
 import A781439635179_TOC from '@/components/9781439635179_toc'
 import A781439635179_AKNOW from '@/components/9781439635179_aknow'
 import A781439635179_INTRO from '@/components/9781439635179_intro'
 import A781439635179_CH1 from '@/components/9781439635179_ch1'
 import A781439635179_CH2 from '@/components/9781439635179_ch2'
 import A781439635179_CH3 from '@/components/9781439635179_ch3'
 import A781439635179_CH4 from '@/components/9781439635179_ch4'
 import A781439635179_CH5 from '@/components/9781439635179_ch5'
 import A781439635179_CH6 from '@/components/9781439635179_ch6'
 import A781439635179_CH7 from '@/components/9781439635179_ch7'
 import A781439635179_INDEX from '@/components/9781439635179_index'
 import A781439635179_BACK from '@/components/9781439635179_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781439635179_toc",
 			"name" : "9781439635179_toc",
 			"component" : A781439635179_TOC
 		},
 		{
 			"path" : "/9781439635179_aknow",
 			"name" : "9781439635179_aknow",
 			"component" : A781439635179_AKNOW
 		},
 		{
 			"path" : "/9781439635179_intro",
 			"name" : "9781439635179_intro",
 			"component" : A781439635179_INTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js